async function fetchConfig() {
  const resp = await fetch('/configuration/config.json');
  const config = await resp.json();  
  return config;
};

export default fetchConfig

// export const dataLinkLocalBackEndUrl = 'https://localhost:49863';
